import styled from "@emotion/styled"
import { graphql } from "gatsby"
import { get } from "lodash"
import React from "react"
import tw from "twin.macro"
import Billboards from "../components/Billboards"
import ContentBlocks from "../components/ContentBlocks"
import Layout from "../components/Layout.js"
import Links from "../components/Links"
import Seo from "../components/Seo.js"
import seoTransformer from "../utils/seoTransformer"

const HomePage = ({ data }) => {
  const { global, page } = data
  const seoMeta = seoTransformer(page)
  const contentBlocks = get(
    page,
    "elements.content_blocks__blocks.value"
  )
  const pageHeading = get(page, "elements.page_heading.value")
  const pageIntroductionText = get(
    page,
    "elements.page_introduction_text.value"
  )
  const pageIntroductionBackground = get(
    page,
    "elements.page_introduction_background.value[0].elements.image.value[0]"
  )
  const pageIntroductionLinks = get(
    page,
    "elements.page_introduction_links.value"
  )
  const billboards = get(page, "elements.billboards.value")

  const TopRow = styled.div`
    ${tw`flex flex-wrap`}
  `
  const HeadingCol = styled.div`
    ${tw`w-full lg:w-1/3 lg:absolute lg:top-0 lg:left-0 lg:h-full order-2 lg:order-1 bg-cover flex items-center`}
    ${props =>
      props.backgroundImage && `
        background-image: url('${props.backgroundImage.url}?w=440fm=jpg&q=100&auto=format');
        @media only screen and (min-resolution: 144dpi) {
          background-image: url('${props.backgroundImage.url}?w=440fm=jpg&q=100&dpr=2&auto=format');
        }
      `}
  `
  const BillboardsCol = styled.div`
    ${tw`lg:w-2/3 lg:ml-auto bg-teal w-full order-1 lg:order-2 relative`}
  `

  const AppendHeader = () => {
    return (
      <TopRow>
        <HeadingCol backgroundImage={pageIntroductionBackground}>
          <HomepageHeading
            heading={pageHeading}
            text={pageIntroductionText}
            links={pageIntroductionLinks}
          />
        </HeadingCol>
        <BillboardsCol>
          <Billboards billboards={billboards} />
        </BillboardsCol>
      </TopRow>
    )
  }

  return (
    <Layout contrastLogo={true} global={global} page={page} appendHeader={<AppendHeader />}>
      <Seo {...seoMeta} />
      <ContentBlocks contentBlocks={contentBlocks} />
    </Layout>
  )
}

export default HomePage

const HomePageHeadingStyled = styled.div`
  ${tw`w-full py-12 px-4 text-center lg:text-left lg:px-12`}
  h1 {
    ${tw`text-5xl font-light text-white leading-none uppercase`}
    em {
      ${tw`font-bold block not-italic`}
    }
  }
  p {
    ${tw`text-white text-lg`}
    + div {
      ${tw`mt-4`}
    }
  }
`

const HomepageHeading = ({ heading, text, links }) => {
  return (
    <HomePageHeadingStyled>
      <h1 dangerouslySetInnerHTML={{ __html: heading }} />
      {text ? <p>{text}</p> : null}
      {links ? (
        <Links
          links={links}
          linkType="underline"
          align="center"
          contrastText={true}
        />
      ) : null}
    </HomePageHeadingStyled>
  )
}

export const query = graphql`
  query HomePageQuery {
    ...Global
    page: kontentItemHomepage {
      system {
        codename
      }
      elements {
        billboards {
          value {
            ...Billboard
          }
        }
        page_heading {
          value
        }
        page_introduction_text {
          value
        }
        page_introduction_links {
          value {
            ...LinkContentItem
          }
        }
        page_introduction_background {
          value {
            ...Image
          }
        }
        content_blocks__blocks {
          value {
            ...ContentBlocks
          }
        }
        seo__meta_title {
          value
        }
        seo__meta_description {
          value
        }
        seo__seo_image {
          value {
            ...Image
          }
        }
      }
    }
  }
`
